module.exports = __webpack_public_path__ + "static/media/Chevevxdange-01.998d21c5.svg";